import React from 'react';
import './custom_modal.css'
import {RiCloseCircleLine} from 'react-icons/ri'

const CustomModal = ({showModal=false,setShowModal,title='Title',icon,children,onClose}) => {

    const closeModal = () => {
        try{
            onClose()
            setShowModal(false)
        }catch{
            setShowModal(false)
        }
    }

    if(showModal){
        return(
            <>
                <div className='custom-modal-overlay' onClick={closeModal}>
                </div>
                <div className="custom-modal custom-bg-light">
                    <header className='row'>
                        <div className='col-8'>
                            {icon}
                            <span>{title}</span>
                        </div>
                        <div className="col-4 text-end">
                            <RiCloseCircleLine color='#DDBB87' size={25} className='ms-auto' onClick={closeModal} />
                        </div>
                    </header>
                        {
                            children
                        }
                </div>
            </>
        )
    }
};

export default CustomModal;